// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Navigation from './components/Navigation.vue'
import Selection from './components/Selection.vue'
import InfoTooltip from './components/InfoTooltip.vue'
import Actions from './components/Actions.vue'
import Toaster from './components/Toaster.vue'
import Mentions from './components/Mentions.vue'
import CommonForm from './components/CommonForm.vue'
import Results from './components/Results.vue'
import ComplexResults from './components/ComplexResults.vue'
import SimpleResults from './components/SimpleResults.vue'
import HomeText from './components/HomeText.vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faTooth, faHospital, faGlasses, faStethoscope, faInfoCircle, faArrowLeft, faCaretDown, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './style.css'

// Formatting
import moment from 'moment'

Vue.filter('formatDate', function (date) {
  if (date) {
    return moment(date).format('DD/MM/YYYY')
  }
})
// Using Bootstrap
Vue.use(BootstrapVue)

// Adding solid svg icons library
library.add(faTooth)
library.add(faHospital)
library.add(faGlasses)
library.add(faStethoscope)
library.add(faInfoCircle)
library.add(faArrowLeft)
library.add(faCaretDown)
library.add(faExclamationTriangle)
// Use Font Awesome Component
Vue.component('font-awesome-icon', FontAwesomeIcon)

// Specific components
Vue.component('actions', Actions)
Vue.component('mentions', Mentions)
Vue.component('common-form', CommonForm)
Vue.component('navigation', Navigation)
Vue.component('selection', Selection)
Vue.component('results', Results)
Vue.component('complex-results', ComplexResults)
Vue.component('simple-results', SimpleResults)
Vue.component('info-tooltip', InfoTooltip)
Vue.component('toaster', Toaster)
Vue.component('home-text', HomeText)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')


// WEBPACK FOOTER //
// ./src/main.js